export default "__VITE_ASSET__f99ad48d__"